export type CardListState = (
  | {
      active: string
      selected?: never
    }
  | {
      active?: never
      selected: string
    }
) & {
  highlighted?: string
}

export const cardStateInList = (id: string, state?: CardListState) => {
  switch (true) {
    case !id:
      return 'default'
    case state?.selected === id:
      return 'selected'
    case state?.active === id:
      return 'active'
    case state?.selected !== undefined:
      return 'disabled'
    default:
      return 'default'
  }
}
